import { useSelector } from 'react-redux';
import { deepEqual } from '../../../../common/utils/objectUtils.js';
import { FixedBroadbandAvailabilityCoCo } from '../../../../components/FixedBroadbandAvailability/FixedBroadbandAvailabilityCoCo.js';
import type { State } from '../../../../selfservice/common/store.js';

export const FixedBroadbandAvailabilityPathCoCo = () => {
  const addressSearchResult = useSelector((state: State) => state?.resources?.addressSearchResult, deepEqual);

  return (
    <FixedBroadbandAvailabilityCoCo
      addressSearchResult={addressSearchResult}
      selectedAddressId={addressSearchResult?.match?.addressId}
    />
  );
};
